import Vue from "vue";
import { ConfirmationBeforeEntry } from "@/model/ConfirmationBeforeEntry";
import { WorkShubetsu } from "@/model/WorkShubetsu";
import { InspectGensha } from "@/model/InspectGensha";
import { InspectDetail } from "@/model/InspectDetail";
import { CarSelectData } from "@/model/CarSelection";
import { InspectRecommend } from "@/model/InspectRecommend";
import { CustomerParams } from "@/model/CustomerParams";
import { NavigationItemParam } from "@/model/NavigationItemParam";
import { CustomerSave } from "@/model/CustomerSave";
import { InspectTime } from "@/model/InspectTime";
import store from "@/store";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import { SpentTime } from "@/model/SpentTime";
import { AssignmentWork } from "@/model/AssignmentWork";
import { EditPriceParam } from '@/model/EditPriceParam';

export default class extends Vue {
  baseAPI = process.env.VUE_APP_API_URL;
  commonAPI = process.env.VUE_APP_API_COMMON_URL;
  token = store.getters["Authentication/token"];

  getReturnHeader(url: string) {
    var promise1 = new Promise((resolve, reject) => {
      const uuid = window.localStorage.getItem("x-shaken-uuid");
      this.$http.get(url, { headers: { auth: this.token, "X-shaken-UUID": uuid } }).then(
        (response: any) => {
          if (response.status == 200) {
            if (response.body) {
              const data = response.body;
              const header = response.headers.map;
              resolve({ ...data, header });
            } else {
              resolve(response.status);
            }
          } else {
            reject({ status: response.status });
          }
        },
        (response: any) => {
          let message = {};
          if (response.body) {
            message = response.body;
          }
          this.handleError(response);
          reject({ status: response.status, ...message });
        }
      );
    });
    return promise1;
  }

  get(url: string) {
    var promise1 = new Promise((resolve, reject) => {
      let headers: any = { auth: this.token }
      if (url.indexOf(this.commonAPI) === -1) {
        const uuid = window.localStorage.getItem("x-shaken-uuid");
        headers = { ...headers, "X-shaken-UUID" : uuid };
      }
      this.$http.get(url, { headers }).then(
        (response: any) => {
          if (response.status == 200) {
            if (response.body) {
              resolve(response.json());
            } else {
              resolve(response.status);
            }
          } else {
            reject({ status: response.status });
          }
        },
        (response: any) => {
          let message = {};
          if (response.body) {
            message = response.body;
          }
          this.handleError(response);
          reject({ status: response.status, ...message });
        }
      );
    });
    return promise1;
  }
  post(url: string, parameter: any, authHeader: boolean = true) {
    let headers: any;
    if (authHeader && this.token != null) {
      const uuid = window.localStorage.getItem("x-shaken-uuid");
      headers = { "Content-Type": "application/json", auth: this.token, "X-shaken-UUID": uuid };
    } else {
      headers = { "Content-Type": "application/json" };
    }
    var promise1 = new Promise((resolve, reject) => {
      this.$http
        .post(url, parameter, {
          headers
        })
        .then(
          (response: any) => {
            if (response.body) {
              resolve({ ...response.body, headers: response.headers.map });
            } else {
              resolve({ status: response.status });
            }
          },
          (response: any) => {
            let message = {};
            if (response.body) {
              message = response.body;
            }
            if (authHeader) {
              this.handleError(response);
            }
            reject({ status: response.status, ...message });
          }
        );
    });
    return promise1;
  }

  delete(url: string, data: any = null) {
    var promise1 = new Promise((resolve, reject) => {
      let req: any;
      const uuid = window.localStorage.getItem("x-shaken-uuid");
      if (data) {
        req = this.$http.delete(url, { headers: { auth: this.token, "X-shaken-UUID": uuid }, body: data });
      } else {
        req = this.$http.delete(url, { headers: { auth: this.token, "X-shaken-UUID": uuid } });
      }
      req.then(
        (response: any) => {
          resolve(response.status);
        },
        (response: any) => {
          this.handleError(response);
          reject(response.status);
        }
      );
    });
    return promise1;
  }

  put(url: string, parameter?: any) {
    var promise1 = new Promise((resolve, reject) => {
      const uuid = window.localStorage.getItem("x-shaken-uuid");
      this.$http
        .put(url, parameter, {
          headers: { auth: this.token, "Content-Type": "application/json", "X-shaken-UUID": uuid }
        })
        .then(
          (response: any) => {
            resolve(response);
          },
          (error: any) => {
            let message = {};
            if (error.body) {
              message = error.body;
            }
            if (url.indexOf("token") == -1) {
              this.handleError(error);
            }
            reject({ status: error.status, ...message });
          }
        );
    });
    return promise1;
  }

  pdf(url: string) {
    var promise1 = new Promise((resolve, reject) => {
      let headers: any = { "Content-Type": "application/pdf", auth: this.token }
      if (url.indexOf(this.commonAPI) === -1) {
        const uuid = window.localStorage.getItem("x-shaken-uuid");
        headers = { ...headers, "X-shaken-UUID" : uuid };
      }
      const header: any = {
        headers: headers,
        responseType: "blob"
      };
      this.$http.get(url, header).then(
        (response: any) => {
          if (response.status == 200) {
            if (response.body) {
              var blob = new Blob([ response.data ]);
              resolve(blob);
            } else {
              resolve(response.status);
            }
          } else {
            reject({ status: response.status });
          }
        },
        (response: any) => {
          let message = {};
          if (response.body) {
            message = response.body;
          }
          this.handleError(response);
          reject({ status: response.status, ...message });
        }
      );
    });
    return promise1;
  }

  authentication(param: { id: string; pass: string }) {
    return this.post(`${this.baseAPI}/auth/token`, param, false);
  }

  refreshToken() {
    return this.put(`${this.baseAPI}/auth/token`);
  }

  logout() {
    return this.delete(`${this.baseAPI}/auth/token`);
  }

  getKbnSkns(sknTitle: string, kbnCd?: String) {
    let path = `${this.baseAPI}/kbnskns/${sknTitle}`;
    if (kbnCd) {
      path += "/" + kbnCd;
    }
    return this.get(path);
  }

  getQuestionnaireList(uketsukeExtendsId: number) { //AK-0001
    let path = `${this.baseAPI}/customer/questionnaire-extreme/${uketsukeExtendsId}`;
    return this.get(path);
  }

  saveQuestionnaire(data: any) { //AK-0001
    return this.put(`${this.baseAPI}/customer/questionnaire-extreme`, data);
  }

  getKbnByKbnCd(kbnCd: string) {
    return this.get(`${this.baseAPI}/kbns?q=kbnCd=${kbnCd}`);
  }

  getStaffs(kyotenCd: string) {
    return this.get(`${this.baseAPI}/staffs?q=kyotenCd=${kyotenCd}`);
  }

  getEnvironment(kyotenCd: string) {
    return this.get(
      `${this.baseAPI}/user/setting/environment?q=kyotenCd=${kyotenCd}`
    );
  }

  //common
  getJuuryouzeiKubuns() {
    return this.get(`${this.commonAPI}/tax/juuryouzei/kubuns`);
  }

  getJuuryouzeiTable(kbn: string, date: string) {
    return this.get(
      `${
      this.commonAPI
      }/tax/juuryouzei/taxTable?q=kazeiKbn=${kbn},targetDate=${date}`
    );
  }

  getJuuryouzeiDetail(code: string) {
    return this.get(`${this.commonAPI}/tax/juuryouzei/detail/${code}`);
  }

  getJibaisekiTable(add1month: number, targetdate: string) {
    return this.get(
      `${
      this.commonAPI
      }/tax/jibaiseki/paymentTable?q=isNewCar=0,add1Month=${add1month},targetDate=${targetdate}`
    );
  }

  getJibaisekiKingaku(jibaisekiCd: string, month: number) {
    return this.get(
      `${this.commonAPI}/tax/jibaiseki/kingaku/${jibaisekiCd}/${month}`
    );
  }
  async calcZeinuki(
    priceZk: number,
    taxRate: number = 80,
    roundedKbn: number = 0
  ) {
    try {
      let res: any = await this.get(
        `${
        this.commonAPI
        }/tax/shouhizei/calcZeinuki?q=price=${priceZk},taxRate=${taxRate},roundedKbn=${roundedKbn}`
      );
      return Promise.resolve(res.zeinuki);
    } catch (ex) {
      return Promise.resolve(priceZk);
    }
  }
  async calcZeikomi(
    priceZn: number,
    taxRate: number = 80,
    roundedKbn: number = 0
  ) {
    try {
      let res: any = await this.get(
        `${
        this.commonAPI
        }/tax/shouhizei/calcZeikomi?q=price=${priceZn},taxRate=${taxRate},roundedKbn=${roundedKbn}`
      );
      return Promise.resolve(res.zeikomi);
    } catch (ex) {
      return Promise.resolve(priceZn);
    }
  }

  /** 2023-10-23 disp uchizei (invoice part 8) [START] */
  async getZeikomi( priceZn: number ){
    return this.get(`${this.baseAPI}/user/getZeikomi/${priceZn}`);
  }
  /** 2023-10-23 disp uchizei (invoice part 8) [END] */

  getServerTime() {
    return this.get(`${this.commonAPI}/etc/serverTime`);
  }

  async getSoukouUnit() {
    return await this.get(`${this.commonAPI}/etc/kbn/soukouUnitKbn`);
  }

  async getSoukouBikou() {
    return await this.get(`${this.commonAPI}/etc/kbn/soukouBikouKbn`);
  }

  convertMiles_Km(value: number, soukouUnitKbn: string = '1') {
    const pathconvert =
      soukouUnitKbn === '1' ? 'convertMilesToKm' : 'convertKmToMiles';
    const path = `${this.commonAPI}/car/soukou/${pathconvert}?q=value=${value}`;

    return this.get(path);
  }

  async asyncGetServerTime() {
    try {
      let serverTime: any = await this.getServerTime();
      return Promise.resolve(serverTime.milliEpoch);
    } catch (ex) {
      return Promise.resolve(new Date().getTime());
    }
  }

  getKanaQ(kanaIndex: string) {
    if (kanaIndex) {
      return `,kanaIndex%3D${kanaIndex}`;
    }
    return "";
  }

  getMakerData(kanaIndex: string) {
    let kana = this.getKanaQ(kanaIndex);
    return this.get(`${this.commonAPI}/car/makers?q=displayKbn=1${kana}`);
  }

  getModelData(makerCd: string, kanaIndex: string) {
    let kana = this.getKanaQ(kanaIndex);
    return this.get(`${this.commonAPI}/car/models?q=makerCd=${makerCd}${kana}`);
  }

  getKyotenList() {
    return this.get(`${this.baseAPI}/kyotens`);
  }

  //navigation
  getNavigation(uketsukeExtendId: number, isCustomer: boolean = false) {
    let pathCustomer = isCustomer ? "/customer" : "";
    return this.get(
      `${this.baseAPI}${pathCustomer}/navigations/${uketsukeExtendId}`
    );
  }

  //sub header
  getSubHeaderData(uketsukeExtendId: number, part: string) {
    return this.get(`${this.baseAPI}/${part}/subheaders/${uketsukeExtendId}`);
  }

  saveSpentTime(data: SpentTime) {
    return this.post(`${this.baseAPI}/spent-time`, data);
  }

  //after press start md-0002
  postNavigtion(uketsukeExtendId: number) {
    return this.post(`${this.baseAPI}/navigations/`, {
      uketsukeExtendId: uketsukeExtendId
    });
  }

  //send current status to api
  putNavigation(param: NavigationItemParam) {
    return this.put(`${this.baseAPI}/navigations/`, param);
  }

  //md-0000
  getReservationList(from: string, to: string) {
    return this.get(
      `${
      this.baseAPI
      }/reservations?q=workPlansYmdFrom=${from},workPlansYmdTo=${to}`
    );
  }

  getWorkShubetsuCategories() {
    return this.get(`${this.baseAPI}/work-shubetsu-categories`);
  }

  getWorkShubetsu() {
    return this.get(`${this.baseAPI}/work-shubetsus`);
  }

  saveWorkShubetsu(works: WorkShubetsu[]) {
    return this.put(`${this.baseAPI}/work-shubetsu-managements`, works);
  }

  getReservationSetting() {
    return this.get(`${this.baseAPI}/reservations/column`);
  }

  updateReservationSetting(data: any[]) {
    return this.put(`${this.baseAPI}/reservations/column`, data);
  }

  //md-0001, ak-0001

  getLaborRate() {
    return this.get(`${this.baseAPI}/seibi-labor-rate`);
  }

  async getReservationDetail(code: string, isCustomer: boolean) {
    let path;
    if (isCustomer) {
      path = `${this.baseAPI}/customer/reservations/${code}`;
    } else {
      path = `${this.baseAPI}/reservations/${code}`;
    }
    return await this.getReturnHeader(path);
  }

  saveMileage(data: CustomerParams) {
    return this.put(`${this.baseAPI}/reservations/soukoukm`, data);
  }

  saveMemo(data: CustomerParams) {
    return this.put(`${this.baseAPI}/reservations/sknmemo`, data);
  }

  saveFrontTantousha(data: CustomerParams) {
    return this.put(`${this.baseAPI}/reservations/front-tantousha`, data);
  }

  saveOmonaYouto(data: CustomerParams) {
    return this.put(`${this.baseAPI}/customer/reservations/omona-youto`, data);
  }

  //md-0001-1, ak-0001-1
  getSupport(kokyakuKanriNo: string) {
    return this.get(
      `${
      this.baseAPI
      }/reservations/histories?q=kokyakuKanriNo=${kokyakuKanriNo}`
    );
  }

  //md-0001-1
  async saveTax(data: JuuryouzeiJibaiseikiSave) {
    return await this.post(`${this.baseAPI}/reservations/meisai-tax`, data);
  }
  saveRateKingakuZn(param: any) {
    return this.put(`${this.baseAPI}/reservations/labor`, param);
  }

  //ak-0001-1-2
  saveConfirmation(param: ConfirmationBeforeEntry) {
    return this.put(
      `${this.baseAPI}/customer/reservations/confirmation-before-entries`,
      param
    );
  }

  //md-0002
  getLiftUse() {
    return this.get(`${this.baseAPI}/lift`);
  }

  saveInsectionDetail(inspectionDetail: InspectDetail) {
    return this.put(
      `${this.baseAPI}/inspection-detail-selection`,
      inspectionDetail
    );
  }

  getInsectionDetail(uketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/inspection-detail-selection/${uketsukeExtendsId}`
    );
  }

  getStaffKensain() {
    return this.get(`${this.baseAPI}/sknstaffs/kensain`);
  }

  getStaffSeibishi() {
    return this.get(`${this.baseAPI}/sknstaffs/seibishi`);
  }

  getStaffHojoseibishi() {
    return this.get(`${this.baseAPI}/sknstaffs/hojoseibishi`);
  }

  getStaffFront() {
    return this.get(`${this.baseAPI}/sknstaffs/front`);
  }

  getSeibiMenuListMaster() {
    return this.get(`${this.baseAPI}/seibi-menu`);
  }

  getSeibiMenuList() {
    return this.get(`${this.baseAPI}/shurui-seibi-menu`);
  }

  saveSeibiMenu(data: any) {
    return this.put(`${this.baseAPI}/shurui-seibi-menu`, data);
  }

  //md-0003
  getCarSelection(uketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/car-selection/${uketsukeExtendsId}`);
  }

  saveCarSelection(data: CarSelectData) {
    return this.put(`${this.baseAPI}/car-selection`, data);
  }

  revertTireSize(data: CarSelectData) {
    return this.put(`${this.baseAPI}/revert-tiresize`, data);
  }

  getKakyuki(makerCd: string, modelCd: string) {
    return this.get(
      `${this.baseAPI}/kakyuki-shashu?q=makerCd=${makerCd},modelCd=${modelCd}`
    );
  }

  getShashu(makerCd: string, modelCd: string, carData: CarSelectData) {
    let q = `makerCd=${makerCd},modelCd=${modelCd}`;
    if (carData.katashiki) {
      q += `,katashiki=${carData.katashiki}`;
    }
    if (carData.engineKatashiki) {
      q += `,engineKatashiki=${carData.engineKatashiki}`;
    }
    if (carData.kakyukiKbn) {
      q += `,kakyukiKbn=${carData.kakyukiKbn}`;
    }
    return this.get(`${this.baseAPI}/shashu?q=${q}`);
  }

  //md-0005
  getInspectLineResult(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/inspect-line/${sknUketsukeExtendsId}`);
  }

  getInspectLineSeibi(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/inspect-line-seibi/${sknUketsukeExtendsId}`);
  }

  saveInspectLineResult(data: any) {
    return this.post(`${this.baseAPI}/inspect-line/`, data);
  }

  saveInspectLineSeibi(data: any) {
    return this.put(`${this.baseAPI}/inspect-line-seibi`, data);
  }

  //md-0004, md-0006
  getInspect(sknUketsukeExtendsId: number, pathName: string) {
    return this.get(`${this.baseAPI}/${pathName}/${sknUketsukeExtendsId}`);
  }

  /** 2021-11-08 sh #7530 improve speed.(No.1) [START] */
  getInspectByCategoryId(sknUketsukeExtendsId: number, pathName: string, sknInspectCategoryId: number) {
    return this.get(`${this.baseAPI}/${pathName}ByCategoryId/${sknUketsukeExtendsId}/${sknInspectCategoryId}`);
  }
  /** 2021-11-08 sh #7530 improve speed.(No.1) [END] */

  saveInspect(data: any, pathName: string) {
    return this.put(`${this.baseAPI}/${pathName}`, data);
  }

  // deleteManualSeibi(manualSeibiId: number) {
  //   return this.delete(`${this.baseAPI}/manual-seibi/${manualSeibiId}`);
  // }

  deleteManualSeibi(data: { sknUketsukeManualSeibiId: number, uketsukeExtendsId: number }) {
    return this.delete(`${this.baseAPI}/manual-seibi`, data);
  }

  deleteManualBuhin(manualSeibiBuhinId: number) {
    return this.delete(`${this.baseAPI}/manual-seibi-buhin/${manualSeibiBuhinId}`);
  }

  sendSocket(sknUketsukeExtendsId: number, sknUketsukeInspectId: number) {
    return this.get(`${this.baseAPI}/inspect-socket/${sknUketsukeExtendsId}/${sknUketsukeInspectId}`);
  }

  //md-0008
  getInspectRecommend(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/recommend-inspect-seibi/${sknUketsukeExtendsId}`
    );
  }

  saveInspectRecommend(data: any) {
    return this.put(`${this.baseAPI}/recommend-inspect-seibi`, data);
  }

  saveInspectRecommendManual(data: any) {
    return this.put(`${this.baseAPI}/recommend-inspect-seibi-manual`, data);
  }

  //md-0009, md-0010, md-0012 update workProgressState
  updateWorkProgressState(data: {
    sknUketsukeExtendsId: number;
    screenCd: string;
    currentWorkProgressState: number;
    uketsukeCd: string;
    yoyakuNo: string;
  }) {
    return this.put(`${this.baseAPI}/workprogress`, data);
  }

  //md-0011
  getAssignmentWork(sknUketsukeExtendsId: number, getFrom: number = -1 ) {
    return this.get(`${this.baseAPI}/workorders/${sknUketsukeExtendsId}/${getFrom}`);
  }

  saveAssignmentWork(data: AssignmentWork) {
    return this.post(`${this.baseAPI}/workorders/`, data);
  }

  getOtherStaffList(sknUketsukeExtendsId: number, workId: any, isManual: boolean) {
    let qWorkId;
    if (isManual) {
      qWorkId = `sknHiyouManualWorkId=${workId}`;
    } else {
      qWorkId = `sknHiyouInspectWorkId=${workId}`;
    }
    return this.get(`${this.baseAPI}/workorders/other-staff?q=sknUketsukeExtendsId=${sknUketsukeExtendsId},${qWorkId}`);
  }

  getStaffList(sknUketsukeExtendsId: number, workId: any, isManual: boolean) {
    let qWorkId;
    if (isManual) {
      qWorkId = `sknHiyouManualWorkId=${workId}`;
    } else {
      qWorkId = `sknHiyouInspectWorkId=${workId}`;
    }
    return this.get(`${this.baseAPI}/workorders/staff?q=sknUketsukeExtendsId=${sknUketsukeExtendsId},${qWorkId}`);
  }

  //md-0015
  getPartSelection(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/part-selection/${sknUketsukeExtendsId}`);
  }

  getPartSelectionBuhin(sknUketsukeExtendsId: number, katashiki: string, engineKatashiki: string
    , seibiMenuCd: string) {
    return this.get(
      `${
      this.baseAPI
      }/part-selection-buhin-extreme?q=sknUketsukeExtendsId=${sknUketsukeExtendsId},katashiki=${katashiki},engineKatashiki=${engineKatashiki},seibiMenuCd=${seibiMenuCd}`
    );
  }

  savePartSelection(data: any) {
    return this.put(`${this.baseAPI}/part-selection`, data);
  }

  // savePartRecommendSeibi(data: any) {
  //   return this.put(`${this.baseAPI}/part-selection-recommend`, data);
  // }

  //md-0014
  saveCompleted(data: any) {
    return this.put(`${this.baseAPI}/completed`, data);
  }

  //ak-0002
  getInsectionCost(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/inspection-cost/${sknUketsukeExtendsId}`
    );
  }

  getInsectionCostQM(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/inspection-cost-qm/${sknUketsukeExtendsId}`
    );
  }

  saveShohiyou(data: any) {
    return this.post(`${this.baseAPI}/customer/shohiyou`, data);
  }

  getRyoukinRank() {
    return this.get(`${this.baseAPI}/customer/inspection-cost/ryoukin-rank`);
  }

  getTaxWeightFromWeb(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/inspection-cost/get-tax-weight-from-web/${sknUketsukeExtendsId}`
    );
  }

  //ak-0003-1
  getInspectSeibi(uketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/inspections-seibi/${uketsukeExtendsId}`
    );
  }

  getInspectSeibiAK3_1(uketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/inspections?q=sknUketsukeExtendsId=${uketsukeExtendsId}`
    );
  }

  getInspectSeibiAK3_2(uketsukeExtendsId: number, id: number, mode: number) {
    let q;
    if (mode == 1) {
      q = `sknUketsukeExtendsId=${uketsukeExtendsId},sknUketsukeInspectionId=${id}`;
    } else if (mode == 2) {
      q = `sknUketsukeExtendsId=${uketsukeExtendsId},sknUketsukeInspectionSeibiId=${id}`;
    }
    return this.get(
      `${this.baseAPI}/customer/inspections?q=${q}`
    );
  }

  updateDoTenken(uketsukeExtendsId: number, doTenken: number,
    sknUketsukeInspectId: any, sknUketsukeInspectSeibiId: any = null, sknUketsukeManualSeibiId: any = null) {
    let data: any = {
      sknUketsukeExtendsId: uketsukeExtendsId,
      doTenken: doTenken
    };
    if (sknUketsukeManualSeibiId) {
      data = { ...data, sknUketsukeManualSeibiId };
    } else if (sknUketsukeInspectSeibiId) {
      data = { ...data, sknUketsukeInspectSeibiId };
    }
    if (sknUketsukeInspectId) {
      data = { ...data, sknUketsukeInspectId };
    }
    return this.put(
      `${this.baseAPI}/customer/inspections`, data
    );
  }

  saveBuhinAk3_2(data: any) {
    return this.put(`${this.baseAPI}/customer/inspections/edit-buhin-price`, data);
  }

  resetBuhinPriceAk3_2(data: any) {
    return this.put(`${this.baseAPI}/customer/inspections/reset-buhin-price`, data);
  }

  //ak-004, ak-0005
  updatePrice(data: EditPriceParam) {
    return this.put(`${this.baseAPI}/customer/inspections/edit-price`, data);
  }
  //ak-0006
  getCoupon(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/customer/coupon/${sknUketsukeExtendsId}`);
  }

  getOption(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/customer/option/${sknUketsukeExtendsId}`);
  }

  saveCoupon(data: any) {
    return this.post(`${this.baseAPI}/customer/coupon`, data);
  }

  saveOption(data: any) {
    return this.post(`${this.baseAPI}/customer/option`, data);
  }

  getCouponLimit(groupCd: any, shatenCd: any, kyotenCd: any) {
    const path =
      `${this.baseAPI}/coupon-limit?q=kyotenCd=${kyotenCd},groupCd=${groupCd},shatenCd=${shatenCd}`;
    return this.get(path);
  }

  handleError(error: any) {
    if (error.status == 401) {
      console.log(error);
      // window.location.reload();
    }
  }

  //ak-0007
  savePayment(data: CustomerSave) {
    return this.post(`${this.baseAPI}/customer/payments`, data);
  }

  getPaymentNotice() {
    return this.get(`${this.baseAPI}/notice`);
  }

  getPayment(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/payments/${sknUketsukeExtendsId}`
    );
  }

  getIsConfirm(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/customer/confirm/${sknUketsukeExtendsId}`);
  }

  saveIsConfirm(data: any) {
    return this.put(`${this.baseAPI}/customer/confirm`, data);
  }

  //save and stop
  clearLiftStaff(sknUketsukeExtendsId: number) {
    return this.put(`${this.baseAPI}/clearliftstaff/${sknUketsukeExtendsId}`);
  }

  async saveRyoukinRank(data: JuuryouzeiJibaiseikiSave) {
    return await this.post(`${this.baseAPI}/reservations/ryoukin-rank`, data);
  }

  saveManualAk5(data: any) {
    return this.put(`${this.baseAPI}/customer/inspections-manual`, data);
  }

  deleteUketsukeManualSeibi(data: any) {
    return this.put(`${this.baseAPI}/customer/inspections-manual-delete`, data);
  }

  updateUketsukeManualSeibi(data: any) {
    return this.put(`${this.baseAPI}/customer/inspections-manual-seibinm`, data);
  }

  saveCancel(data: any) {
    return this.put(`${this.baseAPI}/cancel`, data);
  }

  getTireSize(strTireSize: string) {
    return this.get(
      `${this.baseAPI}/get-tiresize?q=strTireSize=${strTireSize}`
    );
  }

  updateKensaHiyou(data: any) {
    return this.post(`${this.baseAPI}/customer/kensaHiyou`, data);
  }

  resetKensaHiyou(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/reset-kensaHiyou/${sknUketsukeExtendsId}`
    );
  }

  resetKensaHiyouQM(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/customer/reset-kensaHiyou-qm/${sknUketsukeExtendsId}`
    );
  }

  getPlateAreas() {
    return this.get(`${this.commonAPI}/car/plateAreas`);
  }

  saveCarSelectionQuickMitsumori(data: CarSelectData) {
    return this.post(`${this.baseAPI}/car-selection-quick-mitsumori`, data);
  }

  getQuickMitsumoriIdByPlateNo( param: any ) {
    let q = "";
    let query: string[] = [];
    if (param) {
      Object.keys(param).forEach((key: string) => {
        if (param[key]) {
            query.push(`${key}=${param[key]}`);
        }
      });
    }
    if (query.length) {
      q = `?${query.join("&")}`;
    }
    return this.get(
      `${this.baseAPI}/car-selection-quick-mitsumoriid-by-uuid${q}`
    );
  }

  async getPrefectures() {
    return await this.get(`${this.commonAPI}/etc/prefectures`);
  }

  async convertZipToAddress(zipcode: any, prefFlag: any = 0) {

    let zipcodeFirst = zipcode.slice(0 , 3);
    let zipcodeSecond = zipcode.slice(3, zipcode.length);

    const path =
      `${this.commonAPI}/etc/zipCode/convertZipToAddress?q=zipcodeFirst=${zipcodeFirst},zipcodeSecond=${zipcodeSecond},prefFlag=${prefFlag}`;
    return await this.get(path);
  }

  saveCarSelectionQuickMitsumoriCustomer(data: any) {
    return this.post(`${this.baseAPI}/car-selection-quick-mitsumori-customer`, data);
  }

  getPlateAreasFrequent() {
    return this.get(`${this.baseAPI}/car-selection-quick-mitsumoriid-plate-area-frequent`);
  }

  getQuickMitsumoriList(param: any) {
    let q = "";
    let query: string[] = [];
    if (param) {
      Object.keys(param).forEach((key: string) => {
        if (param[key]) {
            query.push(`${key}=${param[key]}`);
        }
      });
    }
    if (query.length) {
      q = `?${query.join("&")}`;
    }
    return this.get(`${this.baseAPI}/car-selection-quick-mitsumori-data${q}`);
  }

  getQuickMitsumoriQrInfo(id: any) {
    return this.get(`${this.baseAPI}/quick/qr/${id}`);
  }

  saveQuickMitsumoriQrInfo(data: any) {
    return this.post(`${this.baseAPI}/quick/qr/img/`, data);
  }

  getCompanyInfo() {
    return this.get(`${this.baseAPI}/company/kyoten-detail`);
  }

  getCustomerCarList(param: any, page: any, size: any) {
    let q = "";
    let query: string[] = [];
    if (param) {
      Object.keys(param).forEach((key: string) => {
        if (param[key]) {
            query.push(`${key}=${param[key]}`);
        }
      });
    }
    if (query.length) {
      q = `&q=${query.join(",")}`;
    }
    return this.get(`${this.baseAPI}/exp-customer-cars?page=${page}&size=${size}&sort=created_at${q}`);
  }

  async getPlateAreasAsync() {
    return await this.get(`${this.commonAPI}/car/plateAreas`);
  }

  updateShakenShurui(inspectionDetail: InspectDetail) {
    return this.put(
      `${this.baseAPI}/update-shaken-shurui`,
      inspectionDetail
    );
  }

  getQmMitsumoriPreview(id: any) {
    return this.get(`${this.baseAPI}/recommend-inspect-seibi-qm-preview-check/${id}`);
  }

  getFunctionSetting() {
    return this.get(`${this.baseAPI}/func/setting`);
  }

  /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
  saveIsConfirmRecommend(data: any) {
    return this.put(`${this.baseAPI}/customer/confirm/recommend`, data);
  }
  saveIsConfirmInspect(data: any) {
    return this.put(`${this.baseAPI}/customer/confirm/inspect`, data);
  }
  /** 2021-05-27 sh #7123 if change price, change the flag. [END] */

  /** 2021-07-21 sh #6989 implement quick mitsumori search.(priority 2) [START] */
  getFunctionSettingPM(){
    return this.get(`${this.baseAPI}/user/functionsetting`);
  }
  getQuickMitsumoriByIdForCustomer(id: any) {
    return this.get(`${this.baseAPI}/car-selection-quick-mitsumori-data/customer/${id}`);
  }
  /** 2021-07-21 sh #6989 implement quick mitsumori search.(priority 2) [END] */
  saveJizenRecommend(data: any) {
    return this.put(`${this.baseAPI}/jizen-recommend`, data);
  }

  getJizenResult(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/jizen-result/${sknUketsukeExtendsId}`);
  }

  getSknEstimate(sknUketsukeExtendsId: number) {
    return this.pdf(`${this.baseAPI}/jizen/exportPdf/${sknUketsukeExtendsId}`);
  }

  getJizenMitsumoriPreview(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/jizen-preview/${sknUketsukeExtendsId}`);
  }

  getJizenVal() {
    return this.get(`${this.baseAPI}/jizen-val`);
  }

  getJizenInspectionSeibi(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/jizen-inspection-seibi/${sknUketsukeExtendsId}`);
  }

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  saveInspectRecommendQm(data: any) {
    return this.put(`${this.baseAPI}/recommend-inspect-seibi-qm`, data);
  }
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */
  updateTSknUketsukeExtends(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/jizen-update/${sknUketsukeExtendsId}`);
  }

  updateSknWorkProgressStateOnHold(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/jizen-on-hold/${sknUketsukeExtendsId}`);
  }
  /** 2021-09-28 sh #7438 implements tech info amount. [START] */
  updateUseTechInfoAmount(data: any) {
    return this.put(`${this.baseAPI}/customer/inspection-cost/tech-info-amount`, data);
  }
  /** 2021-09-28 sh #7438 implements tech info amount. [END] */
  updateUketsukeExtendsNyuukoYmd(inspectionDetail: InspectDetail) {
    return this.put(
      `${this.baseAPI}/update-nyuuko-ymd`,
      inspectionDetail
    );
  }
  getNyuukoInfo(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/nyuuko-info/${sknUketsukeExtendsId}`
    );
  }
  getNavigationJoukyou(sknUketsukeExtendsId: number) {
    return this.get(
      `${this.baseAPI}/navigation-joukyou/${sknUketsukeExtendsId}`
    );
  }

  /** 2021-10-11 sh #7458 change layaout at quick mitsumori. [START] */
  printQuickMitsumori(id: any) {
    return this.pdf(`${this.baseAPI}/qm/exportPdf/${id}`);
  }
  /** 2021-10-11 sh #7458 change layaout at quick mitsumori. [END] */

  /** 2021-10-25 sh #7493 change display of spec. [START] */
  saveJizenDisplayOrder(id: any, data: any) {
    return this.put(`${this.baseAPI}/jizen-display-order/${id}`, data);
  }
  /** 2021-10-25 sh #7493 change display of spec. [END] */

  /** 2021-12-01 sh #7587 change checking of seibiIds. [START] */
  getSelectingSeibiIds(id: any) {
    return this.get(`${this.baseAPI}/getSelectingSeibiDetailIds/${id}`);
  }
  /** 2021-12-01 sh #7587 change checking of seibiIds. [END] */

  // 2022-01-31 morisako kobac-free add [START]
  setFreeOfCharge(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/free-of-charge/${sknUketsukeExtendsId}`);
  }
  getMSknFreeOfCharge(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/free-of-charge-nm/${sknUketsukeExtendsId}`);
  }
  // 2022-01-31 morisako kobac-free add [END]
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
  getManualKouchin(data: any) {
    return this.put(`${this.baseAPI}/manual-kouchin`, data);
  }
  updatePriceForFactory(data: EditPriceParam) {
    return this.put(`${this.baseAPI}/customer/inspections/factory/edit-price`, data);
  }
  saveJizenInspectRecommendManual(data: any) {
    return this.put(`${this.baseAPI}/jizen-recommend-inspect-seibi-manual`, data);
  }
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
  // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
  checkJizenSort(sknUketsukeExtendsId: number) {
    return this.get(`${this.baseAPI}/check-jizen-sort/${sknUketsukeExtendsId}`);
  }
  // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
}
